<template>
  <el-card :class="$setClasses">
    <div v-if="field.title || field.icon" :class="$vClass('title')">
      <font-awesome-icon
        v-if="field.icon"
        :class="$vClass('title__icon')"
        :icon="['fal', field.icon]"
      />
      <span v-if="field.title" :class="[$vPrefix('bold'), $vClass('title__label')]">{{
        field.title
      }}</span>
    </div>
    <div v-if="field.content" :class="$vClass('body')">
      <div v-html="field.content"></div>
    </div>
  </el-card>
</template>

<script>
import Card from "@nextories/vue-core-components/src/components/organisms/NxtCoreCard.vue";

export default {
  extends: Card,
  name: "Card",
  props: {
    field: Object,
  },
};
</script>

<style lang="scss" scoped>
@use "@nextories/vue-core-components/src/assets/scss/components/organisms/NxtCoreCard" with ($prefixName: $prefixName);
</style>
